import { isNull } from 'lodash/fp';

import { ApplicationState } from '../../../../store/types';
import { ColumnSort, TableFilters } from '../../../shared/table/types';
import { DoraMyCompaniesView } from './types';
import { BaseEntity, CompanyEntity, FunctionMigration } from '../../../admin/entity/store/types';
import { DropdownOption } from '../../../shared/dropdown/Dropdown';
import { getDoraCompaniesRoot } from '../../store/selectors';

export const getDoraMyCompaniesView = (state: ApplicationState): DoraMyCompaniesView => getDoraCompaniesRoot(state).myCompaniesView;

export const getDoraCompanyEntityModalOpen = (state: ApplicationState): boolean => getDoraCompaniesRoot(state).companyEntityModalOpen;

export const getSelectedDoraCompanyEntity = (state: ApplicationState): CompanyEntity | null => getDoraCompaniesRoot(state).selectedCompanyEntity;

export const getSavedDoraCompanyEntity = (state: ApplicationState): CompanyEntity | null => getDoraCompaniesRoot(state).savedCompanyEntity;

export const getCurrentEntityFunctionIds = (state: ApplicationState): number[] => getDoraCompaniesRoot(state).currentCompanyEntityFunctionIds;

export const getSelectedEntityFunctionIds = (state: ApplicationState): number[] => getDoraCompaniesRoot(state).selectedCompanyEntityFunctionIds;

export const getPaginatedInScopeDoraCompanies = (state: ApplicationState): CompanyEntity[] => getDoraCompaniesRoot(state).inScopeCompanies;

export const getPaginatedOutOfDoraCompanies = (state: ApplicationState): CompanyEntity[] => getDoraCompaniesRoot(state).outOfScopeCompanies;

export const getIsFetchingCompanies = (state: ApplicationState): boolean => getDoraCompaniesRoot(state).fetchingCompanies;

export const getIsFetchingEntityFunctionIds = (state: ApplicationState): boolean => getDoraCompaniesRoot(state).fetchingEntityFunctionIds;

export const getMyCompanyEntities = (state: ApplicationState): BaseEntity[] => getDoraCompaniesRoot(state).myCompanyEntities;

export const getMyCompanyEntitiesDropdownOptions = (state: ApplicationState): DropdownOption[] => {
    const companyEntities = getDoraCompaniesRoot(state).myCompanyEntities;
    return companyEntities.map(({ name }) => ({ value: name, label: name }));
};

export const getMigrateFunctionConfirmationModalOpen = (state: ApplicationState): boolean => {
    const functionMigration = getDoraCompaniesRoot(state).functionMigration;
    return !isNull(functionMigration) && functionMigration.migrations.length > 0;
};

export const getFunctionMigration = (state: ApplicationState): FunctionMigration | null => getDoraCompaniesRoot(state).functionMigration;

export const getIsCompanyFunctionMigration = (state: ApplicationState): boolean => getDoraCompaniesRoot(state).isCompanyFunctionMigration;

export const getEntityDescriptionModalOpen = (state: ApplicationState): boolean => getDoraCompaniesRoot(state).entityDescriptionOpen;

export const getEntityIsSaving = (state: ApplicationState): boolean => getDoraCompaniesRoot(state).isSavingEntity;

// Table Filters and Pagination
// In scope
export const getInScopeTotalCompanies = (state: ApplicationState): number => getDoraCompaniesRoot(state).inScopeTotalCompanies;
export const getInScopeCompanyFilters = (state: ApplicationState): TableFilters => getDoraCompaniesRoot(state).inScopeCompanyFilters;
export const getInScopeCompanyColumnSort = (state: ApplicationState): ColumnSort | undefined => getDoraCompaniesRoot(state).inScopeCompanySort;
export const getInScopeCompaniesPageNumber = (state: ApplicationState): number => getDoraCompaniesRoot(state).inScopeCompanyPage;
export const getInScopeCompaniesPageSize = (state: ApplicationState): number => getDoraCompaniesRoot(state).inScopeCompanyPageSize;
// Out of scope
export const getOutOfScopeTotalCompanies = (state: ApplicationState): number => getDoraCompaniesRoot(state).outOfScopeTotalCompanies;
export const getOutOfScopeCompanyFilters = (state: ApplicationState): TableFilters => getDoraCompaniesRoot(state).outOfScopeCompanyFilters;
export const getOutOfScopeCompanyColumnSort = (state: ApplicationState): ColumnSort | undefined => getDoraCompaniesRoot(state).outOfScopeCompanySort;
export const getOutOfScopeCompaniesPageNumber = (state: ApplicationState): number => getDoraCompaniesRoot(state).outOfScopeCompanyPage;
export const getOutOfScopeCompaniesPageSize = (state: ApplicationState): number => getDoraCompaniesRoot(state).outOfScopeCompanyPageSize;
